/* AKI EDC theme JS — progressive enhancement only. Everything works without it. */
(function () {
  "use strict";

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var moneyFormat = window.AKI && window.AKI.moneyFormat ? window.AKI.moneyFormat : "${{amount}}";
  var freeShipCents = window.AKI && window.AKI.freeShipCents ? window.AKI.freeShipCents : 7500;

  function money(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, "");
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* ---------- Mobile nav ---------- */
  var burger = document.querySelector("[data-burger]");
  var nav = document.querySelector("[data-nav]");
  if (burger && nav) {
    burger.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---------- Scroll reveals ---------- */
  var reveals = document.querySelectorAll(".reveal");
  if (reveals.length && "IntersectionObserver" in window && !reducedMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px" });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add("in"); });
  }

  /* ---------- Custom cursor (fine pointer, motion allowed) ---------- */
  if (!reducedMotion && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
    var dot = document.createElement("div");
    var ring = document.createElement("div");
    dot.className = "cursor-dot"; ring.className = "cursor-ring";
    dot.setAttribute("aria-hidden", "true"); ring.setAttribute("aria-hidden", "true");
    document.body.appendChild(dot); document.body.appendChild(ring);
    document.body.classList.add("has-custom-cursor");
    var rx = 0, ry = 0, tx = 0, ty = 0;
    document.addEventListener("mousemove", function (e) {
      tx = e.clientX; ty = e.clientY;
      dot.style.transform = "translate(" + tx + "px," + ty + "px) translate(-50%,-50%)";
    });
    (function loop() {
      rx += (tx - rx) * 0.18; ry += (ty - ry) * 0.18;
      ring.style.transform = "translate(" + rx + "px," + ry + "px) translate(-50%,-50%)";
      requestAnimationFrame(loop);
    })();
    document.addEventListener("mouseover", function (e) {
      document.body.classList.toggle("cursor-on-link", !!e.target.closest("a, button, [role=button]"));
    });
  }

  /* ---------- Gourd colorway switcher (signature) ---------- */
  document.querySelectorAll("[data-gourd]").forEach(function (section) {
    var panel = section.querySelector("[data-gourd-panel]");
    var imgs = section.querySelectorAll("[data-colorway-image]");
    var nameEl = section.querySelector("[data-colorway-name]");
    var variantInput = section.querySelector("[data-variant-id]");
    section.querySelectorAll("[data-swatch]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        section.querySelectorAll("[data-swatch]").forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
        btn.setAttribute("aria-pressed", "true");
        var key = btn.getAttribute("data-swatch");
        imgs.forEach(function (im) {
          im.classList.toggle("is-active", im.getAttribute("data-colorway-image") === key);
        });
        if (nameEl) nameEl.textContent = btn.getAttribute("data-label") || key;
        if (variantInput && btn.getAttribute("data-variant")) variantInput.value = btn.getAttribute("data-variant");
        if (panel) {
          var hex = btn.getAttribute("data-hex");
          panel.style.backgroundColor = hex
            ? "color-mix(in srgb, var(--stone) 88%, " + hex + " 12%)"
            : "";
        }
      });
    });
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector("[data-drawer]");
  var overlay = document.querySelector("[data-drawer-overlay]");
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    document.body.classList.add("drawer-open");
    drawer.removeAttribute("inert");
    var closeBtn = drawer.querySelector("[data-drawer-close]");
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    document.body.classList.remove("drawer-open");
    if (drawer) drawer.setAttribute("inert", "");
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-open]")) { e.preventDefault(); renderCart(); openDrawer(); }
    if (e.target.closest("[data-drawer-close]") || e.target === overlay) closeDrawer();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && document.body.classList.contains("drawer-open")) closeDrawer();
  });

  function fetchCart() { return fetch("/cart.js").then(function (r) { return r.json(); }); }

  function renderCart() {
    if (!drawer) return;
    fetchCart().then(function (cart) {
      var itemsEl = drawer.querySelector("[data-cart-items]");
      var totalEl = drawer.querySelector("[data-cart-total]");
      var countEls = document.querySelectorAll("[data-cart-count]");
      countEls.forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      if (totalEl) totalEl.textContent = money(cart.total_price);

      updateUpsell(cart);

      if (!itemsEl) return;
      if (!cart.items.length) {
        itemsEl.innerHTML = '<p class="drawer__empty">Your cart is empty — the fidgets are waiting.</p>';
        return;
      }
      itemsEl.innerHTML = cart.items.map(function (item) {
        return '<div class="line">' +
          '<img src="' + (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, "_128x$1$2") : "") + '" alt="" loading="lazy">' +
          '<div><div class="line__title">' + item.product_title + "</div>" +
          (item.variant_title && item.variant_title !== "Default Title" ? '<div class="mono muted" style="font-size:11px">' + item.variant_title + "</div>" : "") +
          '<div class="line__qty">' +
          '<button data-qty="' + item.key + '" data-dir="-1" aria-label="Decrease quantity">−</button>' +
          "<span>" + item.quantity + "</span>" +
          '<button data-qty="' + item.key + '" data-dir="1" aria-label="Increase quantity">+</button>' +
          "</div></div>" +
          '<span class="price">' + money(item.final_line_price) + "</span></div>";
      }).join("");
    });
  }

  /* ---------- Free-shipping quick-add ---------- */
  var upsellEl = drawer ? drawer.querySelector("[data-upsell]") : null;
  var upsellPool = null;
  if (upsellEl) {
    var poolEl = drawer.querySelector("[data-upsell-pool]");
    if (poolEl) {
      try { upsellPool = JSON.parse(poolEl.textContent); } catch (err) { upsellPool = null; }
    }
  }

  function updateUpsell(cart) {
    if (!upsellEl || !upsellPool || !upsellPool.length) return;
    if (!cart.items.length) { upsellEl.hidden = true; return; }
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.variant_id] = true; });
    var cands = upsellPool.filter(function (p) { return !inCart[p.id]; });
    if (!cands.length) { upsellEl.hidden = true; return; }
    cands.sort(function (a, b) { return a.price - b.price; });
    var pick = cands[0];
    upsellEl.querySelector("[data-upsell-title]").textContent = pick.title;
    upsellEl.querySelector("[data-upsell-price]").textContent = money(pick.price);
    var uimg = upsellEl.querySelector("[data-upsell-img]");
    uimg.src = pick.img || "";
    uimg.alt = pick.title;
    var ubtn = upsellEl.querySelector("[data-upsell-add]");
    ubtn.setAttribute("data-upsell-id", pick.id);
    ubtn.setAttribute("aria-label", "Add " + pick.title + " (" + money(pick.price) + ") to your order");
    upsellEl.hidden = false;
  }

  document.addEventListener("click", function (e) {
    var ub = e.target.closest("[data-upsell-add]");
    if (!ub) return;
    ub.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: parseInt(ub.getAttribute("data-upsell-id"), 10), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error("add failed");
      return r.json();
    }).then(renderCart).catch(function () {}).finally(function () {
      ub.disabled = false;
    });
  });

  document.addEventListener("click", function (e) {
    var qbtn = e.target.closest("[data-qty]");
    if (!qbtn) return;
    fetchCart().then(function (cart) {
      var item = cart.items.find(function (i) { return i.key === qbtn.getAttribute("data-qty"); });
      if (!item) return;
      var qty = item.quantity + parseInt(qbtn.getAttribute("data-dir"), 10);
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: Math.max(0, qty) })
      }).then(renderCart);
    });
  });

  /* AJAX add-to-cart: intercept any product form */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = "Adding…"; }
    fetch("/cart/add.js", { method: "POST", body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function () { renderCart(); openDrawer(); })
      .catch(function () { window.location.href = "/cart"; })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
      });
  });

  renderCart();
})();
